module.exports = __webpack_public_path__ + "img/l6.d0d439e.svg";